import { renderQrCode } from "./utils/qr-code";
import { attachNativeValidation } from "./utils/form-validation";
import { attachImpersonationSearch } from "./utils/impersonation-search";
import { attachRevealTarget } from "./utils/reveal-target";
import { attachAvatarManager } from "./utils/avatar-manager";
import { attachInlineEdit } from "./utils/inline-edit";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll<HTMLElement>("[data-qr-code]").forEach(element => {
        const text = element.dataset.qrCode;
        if (text) {
            void renderQrCode(element, text);
        }
    });

    document.querySelectorAll<HTMLFormElement>("[data-native-validate]").forEach(attachNativeValidation);
    document.querySelectorAll<HTMLElement>("[data-impersonation-search]").forEach(attachImpersonationSearch);
    document.querySelectorAll<HTMLElement>("[data-reveal-target]").forEach(attachRevealTarget);
    document.querySelectorAll<HTMLElement>("[data-avatar]").forEach(attachAvatarManager);
    document.querySelectorAll<HTMLFormElement>("[data-inline-edit]").forEach(attachInlineEdit);
});
